export const APPSTORE_URL = "https://web.mycardglobal.com/";
export const PLAYSTORE_URL =
  "https://play.google.com/store/apps/details?id=com.my_cardng_app.ng&pcampaignid=landing_page";
export const GTAG_CODE = "G-LVV9CW0BYD";

export const QUICK_LOAN_INTEREST_RATE = 5.1;

// Loan Products Data
export const loanProducts = [
  {
    imgSrc: "/assets/images/personalLoan.svg",
    title: (
      <p>
        Personal
        <br />
        Loans
      </p>
    ),
    subtitle:
      "Quick access to funds for your personal needs. Flexible terms from 1-24 months with competitive interest rates.",
    features: [
      "Loan amounts: ₦10,000 - ₦5,000,000",
      "Flexible repayment: 1-24 months",
      "Quick approval process",
    ],
    className: "bg-primary/5",
    textClassName: "text-deep-primary",
  },
  // {
  //   imgSrc: "/assets/images/businessLoan.svg",
  //   title: (
  //     <p>
  //       Business
  //       <br />
  //       Loans
  //     </p>
  //   ),
  //   subtitle:
  //     "Grow your business with accessible financing. Perfect for inventory, equipment, or expansion needs.",
  //   features: [
  //     "Business growth financing",
  //     "Competitive interest rates",
  //     "Tailored repayment plans",
  //   ],
  //   className: "bg-green/5",
  //   textClassName: "text-deep-green",
  // },
  // {
  //   imgSrc: "/assets/images/emergencyLoan.svg",
  //   title: (
  //     <p>
  //       Emergency
  //       <br />
  //       Loans
  //     </p>
  //   ),
  //   subtitle:
  //     "Fast access to funds when you need them most. Get approved quickly for urgent financial needs.",
  //   features: [
  //     "Rapid approval process",
  //     "Same-day disbursement",
  //     "Flexible loan amounts",
  //   ],
  //   className: "bg-pink/5",
  //   textClassName: "text-deep-pink",
  // },
];

// Loan FAQs
export const loanFaqs = [
  {
    question: "What types of loans does MyCardGlobal offer?",
    answer:
      "MyCardGlobal offers Personal Loans. We also provide specialized employer-based loans for select organizations. Loan amounts range from ₦10,000 to ₦5,000,000 with flexible repayment terms from 1 to 24 months.",
  },
  {
    question: "How do I apply for a loan?",
    answer:
      "Simply download the MyCardGlobal app, complete your account setup and KYC verification, then navigate to the Loans section. Select your desired loan product, enter the amount you need, and submit your application. You'll receive an instant eligibility decision.",
  },
  {
    question: "What are the interest rates for loans?",
    answer:
      "Interest rates start from " +
      QUICK_LOAN_INTEREST_RATE +
      "% per month and vary based on the loan product, amount, and your repayment term. We use a declining balance method, which means you pay less interest over time as you repay the principal.",
  },
  {
    question: "How quickly can I get my loan disbursed?",
    answer:
      "Once your loan is approved, funds are typically disbursed within 24 hours directly to your MyCardGlobal wallet or linked bank account. Emergency loans may be processed even faster.",
  },
  {
    question: "What are the repayment options?",
    answer:
      "We offer flexible repayment schedules - you can choose monthly, weekly, or daily repayments. You can also select your preferred repayment day and set up automatic deductions from your savings account or linked bank account.",
  },
  {
    question: "Do I need collateral for a loan?",
    answer:
      "Most of our personal and emergency loans are unsecured, meaning you don't need collateral. Loan approval is based on your credit profile, income verification, and transaction history with MyCardGlobal.",
  },
  {
    question: "Can I repay my loan early?",
    answer:
      "Yes! You can make early repayments or pay off your entire loan before the due date. This may help you save on interest charges.",
  },
  {
    question: "What is the Debt Service Ratio (DSR)?",
    answer:
      "DSR is the percentage of your monthly income that goes toward loan repayments. We use DSR to ensure you can comfortably afford your loan. Our system automatically calculates your available borrowing capacity based on your income and existing obligations.",
  },
];

// Buzz Features Data
export const buzzFeatures = [
  {
    title: "Chat & Pay",
    iconName: "message",
    subtitle:
      "Have conversations and send money in the same place. Buzz your friends, transfer money directly in chat, and keep your messages and transactions in one place.",
  },
  {
    title: "Find Friends",
    iconName: "friends",
    subtitle:
      "Find friends and family on MyCardGlobal by syncing your contacts and connecting with people you know.",
  },
  {
    title: "Earn Rewards",
    iconName: "rewards",
    subtitle:
      "Find friends and family on MyCardGlobal by syncing your contacts and connecting with people you know.",
  },
];

// Buzz FAQs
export const buzzFaqs = [
  {
    question: "What is Buzz?",
    answer:
      "Buzz is MyCardGlobal's social payment feature that combines instant messaging with peer-to-peer money transfers. You can chat with friends and send money seamlessly in one place, making it as easy as sending a text message.",
  },
  {
    question: "How do I start using Buzz?",
    answer:
      "To use Buzz, download the MyCardGlobal app and complete your account setup. Grant contact permissions to sync your phone contacts, and you'll see which friends are already on MyCardGlobal. You can then start chatting and buzzing money instantly.",
  },
  {
    question: "Is Buzz secure?",
    answer:
      "Yes! Buzz uses bank-level encryption to protect your messages and transactions. All money transfers are secured with the same technology that protects your savings and other financial activities on MyCardGlobal.",
  },
  {
    question: "Can I buzz anyone?",
    answer:
      "You can buzz anyone who has a MyCardGlobal account. If your friend doesn't have the app yet, you can invite them directly from Buzz, and they'll be able to join and start receiving buzzes from you.",
  },
  {
    question: "How much does it cost to buzz someone?",
    answer:
      "Buzzing money to other MyCardGlobal users is completely free! There are no transaction fees for peer-to-peer transfers within the app. You only pay when you're sending money to external bank accounts.",
  },
  {
    question: "What are Buzz rewards?",
    answer:
      "Every time you buzz money to someone, you earn MyCardGlobal points. These points can be redeemed for exclusive perks, discounts, and benefits within the app. The more you buzz, the more you earn!",
  },
  {
    question: "Can I buzz someone who doesn't have MyCardGlobal?",
    answer:
      "Not directly, but you can send them an invitation to join MyCardGlobal through Buzz. Once they sign up and complete their account setup, you'll be able to buzz them instantly.",
  },
  {
    question: "Is there a limit to how much I can buzz?",
    answer:
      "Buzz transactions are subject to the same daily and monthly limits as other transfers on your MyCardGlobal account. These limits vary based on your account verification level and transaction history.",
  },
];
